import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "max-w-11 text-wrap" }

import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

import Stepper from 'primevue/stepper';
import StepItem from 'primevue/stepitem';
import Step from 'primevue/step';
import StepPanel from 'primevue/steppanel';

import CalculationViewLink from '@/components/CalculationViewLink.vue';
import { useSelectViewItems } from '@/composables/useSelectViewItems';
import CalculationViewForm from '../components/CalculationViewForm.vue';
import { useHiddenInputs } from '../composables/useHiddenInputs';

import { useCurrentSegment } from '../composables/useCurrentSegment';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationViewStepper',
  props: {
    "selectedItems": {
  type: Object,
  required: true,
},
    "selectedItemsModifiers": {},
  },
  emits: ["update:selectedItems"],
  setup(__props) {

const selectedItems = _useModel<{ [key: string]: number | null }>(__props, 'selectedItems');

const route = useRoute();
const router = useRouter();

const { isHiddenInputs } = useHiddenInputs();

const { currentSegmentGroupsViews, currentSegment } = useCurrentSegment();

const currentStepperValue = computed(() => {
  return (
    Number(
      currentSegmentGroupsViews.value?.views?.findIndex(
        (view) => view.id === Number(route.params.viewId)
      )
    ) + 1
  );
});

const handleStepperUpdate = (event: number) => {
  router.push({
    name: 'CalculationViewItems',
    params: {
      ...route.params,
      viewId: currentSegmentGroupsViews.value?.views[event - 1]?.id || null,
    },
  });
};
const { viewLinks } = useSelectViewItems(selectedItems);

const mergedLinks = computed(() => {
  const segmentLinks = (currentSegment.value?.links as any[]) || [];
  const selectedViewLinks = (viewLinks as any)?.value ?? (viewLinks as any) ?? [];
  return [...segmentLinks, ...selectedViewLinks];
});


return (_ctx: any,_cache: any) => {
  const _directive_auto_animate = _resolveDirective("auto-animate")!

  return (_unref(currentSegmentGroupsViews))
    ? _withDirectives((_openBlock(), _createBlock(_unref(Stepper), {
        key: 0,
        value: currentStepperValue.value,
        "onUpdate:value": handleStepperUpdate
      }, {
        default: _withCtx(() => [
          (mergedLinks.value.length > 0)
            ? (_openBlock(), _createBlock(CalculationViewLink, {
                key: 0,
                links: mergedLinks.value
              }, null, 8, ["links"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentSegmentGroupsViews)?.views.filter(
        (view) => view.items.some((item) => !item.is_hidden) || !_unref(isHiddenInputs)
      ), (view, index) => {
            return (_openBlock(), _createBlock(_unref(StepItem), {
              value: index + 1,
              key: view.id
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Step), null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_1, _toDisplayString(view.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_unref(StepPanel), null, {
                  default: _withCtx(() => [
                    _createVNode(CalculationViewForm, {
                      "selected-items": selectedItems.value,
                      "onUpdate:selectedItems": _cache[0] || (_cache[0] = ($event: any) => ((selectedItems).value = $event))
                    }, null, 8, ["selected-items"])
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["value"])), [
        [_directive_auto_animate]
      ])
    : _createCommentVNode("", true)
}
}

})